import React, { useState, useCallback, useEffect } from 'react'
import { hooks } from '@front/volcanion'

import { Loader } from '@front/squirtle'

import HookUtils from '@front/volcanion/utils/hooks'

const withContainer = Component => ({ isLoading = false, ...props }) => {
  const location = hooks.useLocation()
  const navigate = hooks.useNavigate()
  const [company] = hooks.useGlobalState('persist.selectedCompany')
  const [user, state] = hooks.useActiveUser({ populate: ['info', 'customerinfo', 'auth', 'user_companies'] })
  const [inPanel, setInPanel] = useState(true)
  const initialRoleFilter = hooks.useCompanyFilter(company, { model_name: 'order' })
  const user_id = user?.user_id

  const [company_users, , company_users_state] = hooks.useModelSearch('companyuser', 'get', {
    initial_filter: { user: user_id, status: ['active'], administration_level: { '!': null } },
    forced_filter: { user: user_id, status: ['active'], administration_level: { '!': null } },
    watchers: [user_id],
    populate: ['company']
  })

  const [administration_level] = hooks.useModelSearch('companyuser', 'get', {
    initial_filter: { user: user_id, company: company },
    forced_filter: { user: user_id, company: company },
    populate: ['user'],
    mutator: 'administration_level',
    watchers: [user_id],
    single: true
  })

  const canCreate = administration_level === 'company'
  const hasCompanies = !_.isEmpty(company_users)

  const onInPanelChange = useCallback(() => {
    setInPanel(!inPanel)
  }, [setInPanel, inPanel])

  useEffect(() => {
    if (!canCreate && _.includes(location?.pathname, 'create')) {
      navigate('/404')
    }
  }, [canCreate, location, navigate]);

  const mergedProps = {
    hasCompanies,
    inPanel,
    onInPanelChange,
    initialRoleFilter,
    company,
    user
  }
  return (
    <Loader isLoading={HookUtils.getLoadingState([company_users_state, state])}>
      <Component {...mergedProps} />
    </Loader>
  )
}

export default withContainer
